import React, {useContext} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {Button} from 'react-bootstrap';
import {NotificationManager} from 'react-notifications';

import {AppContext} from '../AppContext';
import {tre} from '../trebus'

export default function UserDeleted() {

    const context = useContext(AppContext);
    const navigate = useNavigate();
    const { id } = useParams();

    const recoverUser = () => {
        tre.api(
            'PUT',
            '/users/' + id + '/recover',
            {
                context: context,
                success: () => {
                    NotificationManager.success('Usuario recuperado');
                    navigate('/users');
                }
            }
        );
    }

    return (
        <div className="container">
            <h1>Usuario eliminado</h1>
            Si quiere recuperar el usuario pulse "recuperar"

            <br/><br/>

            <Button
                variant="outline-secondary"
                onClick={() => recoverUser()}>
                Recuperar el usuario
            </Button>
        </div>
    )
}
